var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleFilledCross = function SvgIconCircleFilledCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC3D3D",
    fillRule: "evenodd",
    d: "M9 1.125a7.875 7.875 0 1 1 0 15.75 7.875 7.875 0 0 1 0-15.75m3.712 4.163a1.125 1.125 0 0 0-1.59 0L9 7.41 6.879 5.29a1.125 1.125 0 1 0-1.591 1.59L7.408 9l-2.12 2.121a1.125 1.125 0 0 0 1.59 1.592L9 10.59l2.121 2.122a1.125 1.125 0 0 0 1.591-1.591L10.591 9l2.121-2.121c.44-.44.44-1.152 0-1.59",
    clipRule: "evenodd"
  })));
};
export default SvgIconCircleFilledCross;